import React from 'react';

import ModalWithoutTitle from 'components/ui/ModalWithoutTitle';

import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import Form from '../Form/Index';

import actions from '../../Actions';

export default function Index({ enterpriseId, refresh }) {
  const navigate = useNavigate();

  const onSave = (values) => {
    actions.create(enterpriseId, values, () => {
      navigate(routes.admin.enterprise_briefs.index(enterpriseId));
      refresh();
    }, () => {
      alert('error');
    });
  };

  return (
    <ModalWithoutTitle
      show
      onHide={() => navigate(-1)}
    >

      <Form onSave={onSave} data={null} enterpriseId={enterpriseId} />
    </ModalWithoutTitle>
  );
}
